import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';

import { IAuroraState } from '@apps/aurora.state';
import * as fromRootStore from '@apps/root/store';
import { Impersonation } from '@apps/root/models';
import { BackAuthUserSearchResult } from '@common/models/search-result';

import { SpecificComponent } from '../specific.component';
import { User } from '@apps/auth/domain/models/back';
import { Its2Constants } from '@apps/its2/its2.constants';

@Component({
    selector: 'aa-search-result-back-auth-user',
    templateUrl: './back-auth-user.component.html',
    styleUrls: [
        '../../../../../../admin/users/columns-shared.scss',
        '../specific-shared.scss',
        './back-auth-user.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BackAuthUserComponent extends SpecificComponent<BackAuthUserSearchResult>
{
    constructor (
        private store: Store<IAuroraState>,
        private router: Router
    )
    {
        super();
    }

    onImpersonate (event: MouseEvent, user: User)
    {
        event.stopPropagation();
        event.stopImmediatePropagation();

        const impersonation = new Impersonation(user);

        this.store.dispatch( fromRootStore.RootImpeStoreActions.RootImpersonateSet({ impersonation }) );
        this.store.dispatch(fromRootStore.RootSearchStoreActions.RootSearchResultsClearRequested());
        this.router.navigate(Its2Constants.RequestsRoute());
    }
}
